import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DashboardHeader from './DashboardHeader';
import DashboardManager from './DashboardManager';
import DashboardPopup from './DashboardPopup';
import DashboardOpportunity from './DashboardOpportunity';
import DashboardWallet from './DashboardWallet';
import DashboardError from './DashboardError';
export default function Dashboard() {
    return (_jsxs(_Fragment, { children: [_jsx(DashboardHeader, {}), _jsx(DashboardManager, { children: (status, data) => ((status === 'FAIL')
                    ? _jsx(DashboardError, {})
                    : (_jsxs(_Fragment, { children: [_jsx(DashboardPopup, { status: status, data: data }), _jsx(DashboardOpportunity, { status: status, data: data }), _jsx(DashboardWallet, { status: status, data: data === null || data === void 0 ? void 0 : data.wallet })] }))) })] }));
}
